import { PropsWithChildren } from "react";
import "./Shimmer.scss";

export const Shimmer = ({ children }: PropsWithChildren) => (
  <div className="c-shimmer">{children}</div>
);
